import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { MatInputModule } from '@angular/material/input'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { NgxMaskDirective } from 'ngx-mask'
import { ConsultantService } from '../../../../core/services/person/consultant/consultant.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import moment from 'moment/moment'
import { emailValidator } from '../../../../shared/utils/email_validator'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'modal-consultant-client-form-create',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
  ],
  templateUrl: './modal-consultant-client-form-create.component.html',
  styleUrl: './modal-consultant-client-form-create.component.scss',
  providers: [ConsultantService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalConsultantClientFormCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private consultantService: ConsultantService,
    private dialogRef: MatDialogRef<ModalConsultantClientFormCreateComponent>,
    private snackbar: SnackbarCustomService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.idClient = data.item
    }
    const today = new Date() // Data atual
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
  }

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() responseModal = new EventEmitter()
  idClient: number = -1
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined

  listType: any[] = []

  maxDate!: Date

  ngOnInit(): void {
    this.createForm()
  }

  close() {
    this.dialogRef.close()
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', [Validators.required, emailValidator()]],
      birth: [''],
    })
  }

  createConsultant() {
    this.loading = true
    const model = this.createModel()
    this.consultantService.createConsultant(model).subscribe({
      next: (response: any) => {
        if (response.statusCode == 200) {
          this.addConsultant(response.data.id, response.message)
        } else {
          this.snackbar.info(response.message)
          this.loading = false
        }
        // this.snackbar.success(response.message)
        // this.response.emit({ refresh: true, clear: true })
        // this.resetForm()
      },
      error: (err: ErrorRequestModel) => {
        let response: any = err.error
        if (response.statusCode == 409) {
          this.addConsultant(response.data.id, response.message)
        } else {
          this.loading = false
          this.snackbar.errorRequest(err)
        }
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  addConsultant(
    idConsultant: number,
    message: string = 'Cadastrado com sucesso.',
  ) {
    const model = {
      consultorId: idConsultant,
      clienteId: this.idClient,
    }
    this.consultantService.addConsultantClient(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(message)
        this.responseModal.emit({ refresh: true, clear: true })
        this.close()
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
  //
  // editConsultant() {
  //   this.loading = true
  //   const model = this.createModel()
  //   this.consultantService.editConsultant(model).subscribe({
  //     next: (response: any) => {
  //       this.snackbar.success(response.message)
  //       this.responseModal.emit({ refresh: true, clear: true })
  //       this.resetForm()
  //       this.loading = false
  //     },
  //     error: (err: ErrorRequestModel) => {
  //       this.loading = false
  //       this.snackbar.errorRequest(err)
  //     },
  //     complete: () => {
  //       this.loading = false
  //     },
  //   })
  // }

  createModel() {
    return {
      // clienteId: this.idClient,
      nome: this.form.controls['name'].value,
      email: this.form.controls['email'].value,
      telefone: this.form.controls['phone'].value,
      nascimento:
        this.form.controls['birth'].value != ''
          ? moment(this.form.controls['birth'].value).format('DD/MM/YYYY')
          : '',
    }
  }

  openDatepicker() {
    if (this.datepicker) {
      this.datepicker.open()
    }
  }
}
